export const AIRTABLE_BASE = 'appvvwbyjEWlNFXVk';
export const AIRTABLE_APIKEY = 'keyajelld9aZoAKi8';

export const AIRTABLE_URL = `https://api.airtable.com/v0/${AIRTABLE_BASE}`;


export const HIGHTLIGHTS_ID = "recfZDN8LMltTGGyS";

export const SCREEN_RATIO = 0.54;